import React, { useState, useContext } from 'react'
import { useMutation } from '@apollo/client'
import { Form, Button, Header, Loader } from 'semantic-ui-react'
import MixpanelTracker from '../../utils/MixpanelTracker'
import {
  CREATE_STRIPE_CONNECTION_LINK,
  DISCONNECT_STRIPE_MUTATION,
} from '../../graphql/stripe'
import DataContext from '../../contexts/DataContext'
import MessageContext from '../../contexts/MessageContext'

const DefaultPanel = () => {
  const { advisor, countries } = useContext(DataContext)
  const { setAlertMsg } = useContext(MessageContext)
  const stripeCountries = countries.filter((c) => c.stripe !== 'not supported')
  const stripeCountryOptions = stripeCountries.map((c) => ({
    key: c.code,
    value: c.code,
    text: c.name,
    flag: c.code,
  }))
  const defaultCountryCode = stripeCountries.find(
    (c) => c.name === advisor.expert.country
  )?.code

  const [stripeCountryCode, setStripeCountryCode] = useState(defaultCountryCode)
  const [pageLoading, setPageLoading] = useState(false)

  const [getStripeConnectionLink, { loading }] = useMutation(
    CREATE_STRIPE_CONNECTION_LINK,
    {
      context: { skipGlobalErrorHandling: true },
      onCompleted: ({ createStripeConnectionLink }) => {
        MixpanelTracker.trackConnectToStripe()
        setPageLoading(true)
        window.location.replace(createStripeConnectionLink)
      },
      onError: (err) => {
        let alertTitle = 'Failed to Connect to the Stripe Account'
        let alertContent = `Connecting to the Stripe account failed due to: ${err.message}. Please try again later or contact our support team at help@dexterexperts.com.`

        if (err.message === 'Duplicate Stripe ID') {
          alertTitle += ': Duplicate Stripe ID'
          alertContent =
            'Connecting to the Stripe account failed because it is already in use by another account. Each Stripe account can only be linked to one account at a time. If you believe this is an error or need further assistance, please contact our support team at help@dexterexperts.com for help.'
        }

        setAlertMsg({
          title: alertTitle,
          content: alertContent,
          onClose: () => (window.location.href = '/payment'),
        })
      },
    }
  )
  const [disconnectStripe] = useMutation(DISCONNECT_STRIPE_MUTATION, {
    context: { skipGlobalErrorHandling: true },
    onCompleted: () => window.location.reload(),
    onError: (err) => alert(err.message),
  })

  const renderStripeConnection = () => {
    const stripeData = advisor.expert.stripeAccount.data
    return (
      <div className="inline field">
        {!stripeData ? (
          <div>
            <h3>Select the country you are located in</h3>
            <br />
            <Form.Dropdown
              placeholder="Select Country"
              fluid
              search
              selection
              value={stripeCountryCode}
              options={stripeCountryOptions}
              onChange={(e, { value }) => setStripeCountryCode(value)}
            />
          </div>
        ) : (
          <Header as="h3">
            You have not completed the Stripe connect process.
            <Header.Subheader>
              Please continue or restart the process.
            </Header.Subheader>
          </Header>
        )}
        <br />
        <Button
          primary
          onClick={() =>
            getStripeConnectionLink({
              variables: { countryCode: stripeCountryCode },
            })
          }
          loading={loading}
          disabled={loading || (!stripeData && !stripeCountryCode)}
          className="stripe-connect-btn"
        >
          {stripeData
            ? 'Continue connecting with Stripe'
            : 'Connect with Stripe'}
        </Button>
        {stripeData && (
          <Button
            negative
            onClick={() => disconnectStripe()}
            loading={loading}
            disabled={loading}
            className="stripe-connect-btn"
          >
            Restart the entire process
          </Button>
        )}
      </div>
    )
  }

  if (pageLoading) return <Loader active />

  return (
    <div className="bank-section">
      <div className="connect-section">{renderStripeConnection()}</div>
    </div>
  )
}

export default DefaultPanel
